import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/")({
  head: () => ({
    meta: [
      // Indexable since 1 Oct 2026 (approved by Anthony): Ahrefs reported
      // "Noindex page receives organic traffic" for this page. The booking
      // pages for single clinics stay noindex.
      { title: "Schedule a Free Hair Transplant Consultation | RESTORE Hair" },
      {
        name: "description",
        content:
          "Book your complimentary RESTORE Hair consultation. Choose a time that works for you and meet with a hair restoration specialist.",
      },
      { property: "og:title", content: "Schedule a Free Hair Transplant Consultation | RESTORE Hair" },
      {
        property: "og:description",
        content:
          "Book your complimentary RESTORE Hair consultation online.",
      },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/schedule-a-consult/" }],
  }),
  component: ScheduleAConsultPage,
});

function ScheduleAConsultPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed
            src="https://app.squarespacescheduling.com/schedule.php?owner=24213130"
            initialHeight={1600}
          />
        </div>
      </main>
      <Footer />
    </div>
  );
}